import React, { ReactNode, useState } from 'react';
import styled from '@emotion/styled';
import { mqMin } from 'utils/responsive';
import TitleImg from 'ui/images/article/beginner_title.svg';
import Person01Img from 'ui/images/article/person_01.svg';
import Person02Img from 'ui/images/article/person_02.svg';
import Person03Img from 'ui/images/article/person_03.svg';
import { SectionPanel } from 'ui/components/features/MaForBeginner/SectionPanel';
import { useMaForBeginnerModal } from 'ui/components/screens/modals/MaForBeginner/MaForBeginnerModal';
import { MaForBeginnerDetail } from 'ui/components/screens/modals/MaForBeginner/MaForBeginnerDetail';
import { MaForBeginnerDerail_1_1 } from 'ui/components/screens/modals/MaForBeginner/MaForBeginnerDerail_1_1';
import { MaForBeginnerDerail_1_2 } from 'ui/components/screens/modals/MaForBeginner/MaForBeginnerDerail_1_2';
import { MaForBeginnerDerail_1_3 } from 'ui/components/screens/modals/MaForBeginner/MaForBeginnerDerail_1_3';
import { MaForBeginnerDerail_2_1 } from 'ui/components/screens/modals/MaForBeginner/MaForBeginnerDerail_2_1';
import { MaForBeginnerDerail_2_2 } from 'ui/components/screens/modals/MaForBeginner/MaForBeginnerDerail_2_2';
import { MaForBeginnerDerail_2_3 } from 'ui/components/screens/modals/MaForBeginner/MaForBeginnerDerail_2_3';
import { MaForBeginnerDerail_3_1 } from 'ui/components/screens/modals/MaForBeginner/MaForBeginnerDerail_3_1';
import { MaForBeginnerDerail_3_2 } from 'ui/components/screens/modals/MaForBeginner/MaForBeginnerDerail_3_2';
import { MaForBeginnerDerail_3_3 } from 'ui/components/screens/modals/MaForBeginner/MaForBeginnerDerail_3_3';
import { Only } from 'ui/components/elements/Only/Only';

const Wrapper = styled.div`
    width: 100%;
    background-color: var(--cream);
    padding: 2rem 20px;

    ${mqMin('NARROW')} {
        padding: 4.4rem 3rem 2rem 3rem;
    }
`;

const Container = styled.section`
    position: relative;
    width: 100%;
    max-width: 1394px;
    margin: 0 auto;
`;

const ContentWrapper = styled.div`
    position: relative;
    width: 100%;
`;

const UnionShape = styled.div`
    position: relative;
    width: 100%;
`;

const TopArch = styled.div`
    position: absolute;
    left: 50%;
    top: 1rem;
    transform: translateX(-50%);
    width: 8rem;
    height: 4.2rem;
    background: #fff;
    border: 2px solid #ee793f;
    border-bottom: 2px solid #fff;
    z-index: 2;
    border-radius: 200px 200px 0 0;
    display: flex;
    align-items: center;
    justify-content: center;
    overflow: hidden;
    top: -4rem;

    ${mqMin('NARROW')} {
        width: 13.3rem;
        height: 6.5rem;
        top: -6.3rem;
        border-radius: 13.3rem 13.3rem 0 0;
    }
`;

const TitleImage = styled.img`
    width: 4.7rem;
    margin-top: 0;
    object-fit: contain;

    ${mqMin('NARROW')} {
        width: 8rem;
        margin-top: 1rem;
    }
`;

const BorderedBox = styled.div`
    position: relative;
    width: 100%;
    background: #fff;
    border: 2px solid #ee793f;
    border-radius: 16px;
    padding: 1rem 1rem 2rem 1rem;
    align-items: stretch;
    margin-top: 105px;

    ${mqMin('SP')} {
        margin-top: 4rem;
    }

    ${mqMin('NARROW')} {
        padding: 2rem 3rem 3rem 3rem;
    }
`;

const Title = styled.h2`
    font-size: 1.2rem;
    margin-bottom: 30px;
    font-weight: 700;
    text-align: center;

    ${mqMin('NARROW')} {
        font-size: 1.8rem;
    }
`;

const HorizontalContainer = styled.div`
    display: flex;
    flex-direction: column;
    align-items: stretch;
    gap: 3rem;

    ${mqMin('SP')} {
        flex-direction: row;
        justify-content: center;
        align-items: stretch;
    }

    ${mqMin('NARROW')} {
        gap: 5rem;
        flex-direction: row;
        align-items: stretch;
    }
`;

const contents = [
    {
        number: '01',
        title: 'M&A（第三者承継）とは',
        imageUrl: Person01Img,
        menuItems: [
            {
                text: '事業承継の種類',
                content: <MaForBeginnerDerail_1_1 />,
            },
            {
                text: '直接取引と仲介取引',
                content: <MaForBeginnerDerail_1_2 />,
            },
            {
                text: 'M&Aの全体の流れ',
                content: <MaForBeginnerDerail_1_3 />,
            },
        ],
    },
    {
        number: '02',
        title: '仲介会社ってなに？',
        imageUrl: Person02Img,
        menuItems: [
            {
                text: '仲介会社の役割',
                content: <MaForBeginnerDerail_2_1 />,
            },
            {
                text: '仲介会社のしごと',
                content: <MaForBeginnerDerail_2_2 />,
            },
            {
                text: '仲介会社の種類',
                content: <MaForBeginnerDerail_2_3 />,
            },
        ],
    },
    {
        number: '03',
        title: 'さあ、M&Aをはじめよう',
        imageUrl: Person03Img,
        menuItems: [
            {
                text: 'MAnyでの登録の仕方',
                content: <MaForBeginnerDerail_3_1 />,
            },
            {
                text: 'どうしてトラブルが発生するの？',
                content: <MaForBeginnerDerail_3_2 />,
            },
            {
                text: '最初に聞くべき10ポイント',
                content: <MaForBeginnerDerail_3_3 />,
            },
        ],
    },
];

export const MaForBeginner: React.FC = () => {
    const { openModal, closeModal, createModal } = useMaForBeginnerModal();
    const [selectedItem, setSelectedItem] = useState<{ text: string; content: ReactNode } | null | undefined>(null);

    const handleMenuItemClick = (item: { text: string; content: ReactNode } | null | undefined) => {
        setSelectedItem(item);
        openModal();
    };

    return (
        <Wrapper>
            <Container>
                <ContentWrapper>
                    <UnionShape>
                        <TopArch>
                            <TitleImage src={TitleImg} />
                        </TopArch>
                        <BorderedBox>
                            <Title>
                                事業承継について
                                <Only sp>
                                    <br />
                                </Only>
                                相談する前に知っておこう！
                            </Title>
                            <HorizontalContainer>
                                {contents.map((content) => (
                                    <SectionPanel
                                        key={content.number}
                                        number={content.number}
                                        title={content.title}
                                        imageUrl={content.imageUrl}
                                        menuItems={content.menuItems.map((item) => ({
                                            ...item,
                                            onClick: () => handleMenuItemClick(item),
                                        }))}
                                    />
                                ))}
                            </HorizontalContainer>
                        </BorderedBox>
                    </UnionShape>
                </ContentWrapper>
            </Container>
            {createModal(
                <MaForBeginnerDetail itemText={selectedItem?.text || ''} onClose={closeModal}>
                    {selectedItem?.content}
                </MaForBeginnerDetail>,
                {
                    onClose: closeModal,
                },
            )}
        </Wrapper>
    );
};
